module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理商:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agent))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "园所:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.school))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "送课原因:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.SendLessonReasonName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置赠送课时数:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "0px"
    },
    attrs: {
      "data": _vm.form.GiftList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "项目",
      "prop": "ProBrandName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程类型",
      "prop": "ProductName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "赠送课时",
      "prop": "ProNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.ClassNum > 0),
      expression: "form.ClassNum>0"
    }],
    attrs: {
      "label": "上课班级数:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.ClassNum))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.SendLessonReason == 7),
      expression: "form.SendLessonReason==7"
    }],
    attrs: {
      "label": "OA工作流编号:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.OACode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细说明赠课原因:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.SendLessonRemark))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAudit),
      expression: "!isAudit"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核状态:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.OrderStatusName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.AuditRemark !== null),
      expression: "form.AuditRemark!==null"
    }],
    attrs: {
      "label": "审核备注:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.AuditRemark))])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAudit),
      expression: "isAudit"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核意见："
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.auditFormData.OrderStatus),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "OrderStatus", $$v)
      },
      expression: "auditFormData.OrderStatus"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审核备注："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.auditFormData.AuditRemark),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "AuditRemark", $$v)
      },
      expression: "auditFormData.AuditRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.AddDialogVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAudit),
      expression: "isAudit"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("审核")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c0b760d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchoolOrder/components/addSendLessonView/index.vue
// module id = 1559
// module chunks = 1